import { render, staticRenderFns } from "./Requisites.vue?vue&type=template&id=ed7ee448&scoped=true&"
import script from "./Requisites.vue?vue&type=script&lang=ts&"
export * from "./Requisites.vue?vue&type=script&lang=ts&"
import style0 from "./Requisites.vue?vue&type=style&index=0&id=ed7ee448&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7ee448",
  null
  
)

export default component.exports